//@flow

import React from "react";

const Spinner = (): React$Element<"div"> => <div className="spinner" />;

export default Spinner;
